import { React } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

import '../../main.css'
import './CTAButton.css'
import './MCTAButton.css'

export default function CTAButton(props) {
  const variant = props.variant || 'primary'
  const sizeClass = props.size === 'sm' ? ' btn-sm' : props.size === 'lg' ? ' btn-lg' : ''
  const blockClass = props.block ? ' btn-block' : ''
  const disabledAttr = props.disabled ? { 'aria-disabled': 'true' } : {}
  const wrapperClass = props.block ? ' cta-block-wrapper' : ''

  return (
    <a
      className={'cta-wrapper' + wrapperClass}
      onClick={() => !props.disabled && props.onclick()}
      role="button"
      tabIndex={props.disabled ? -1 : 0}
      onKeyDown={(e) => { if (!props.disabled && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); props.onclick() } }}
      {...disabledAttr}
    >
      <span className={'btn btn-' + variant + sizeClass + blockClass + ' noselect ' + (props.className || '')}>
        {props.title}
        {props.hideArrow !== true ? <FontAwesomeIcon icon={faArrowRight} /> : ''}
      </span>
    </a>
  )
}
